import React from 'react';
import { Dropdown } from '@ff-os/shared-react/components/dropdown/Dropdown';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { ColorChoice } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';
import { ColorAttributeDropdownItem } from './ColorAttributeDropdownItem';
import { ColorAttributeDropdownList } from './ColorAttributeDropdownList';
import { ColorAttributeDropdownMobile } from './ColorAttributeDropdownMobile';
import styles from './ColorAttributeDropdown.module.scss';

export const ColorAttributeDropdown = ({ selected, variableIds }: Props) => {
    const isMobile = useMobile();
    if (isMobile) {
        return (
            <ColorAttributeDropdownMobile
                renderPreview={() => <ColorAttributeDropdownItem {...selected} />}
                variableIds={variableIds} />
        );
    } else {
        return (
            <Dropdown
                fieldClassName={styles.dropdown}
                renderPreview={() => <ColorAttributeDropdownItem {...selected} />}>
                <ColorAttributeDropdownList variableIds={variableIds} />
            </Dropdown>
        );
    }
};

type Props = {
    variableIds: string[];
    selected: ColorChoice;
};